// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falEllipsisVertical: CreateIconOptions = {
  "displayName": "FALEllipsisVertical",
  "viewBox": "0, 0, 128, 512",
  "d": "M64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-160a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM96 96A32 32 0 1 0 32 96a32 32 0 1 0 64 0z"
};
